/**
 * Check-in member roles as the backend emits them.
 *
 * These strings originate in the backend's `checkin_member_role_enum`
 * (gb-data-platform-backend src/enum/common.ts) and arrive here as free text on
 * report and deduction payloads. This dashboard only READS them — it never
 * submits one — so drift is not a failed request; it degrades quietly instead
 * (an unstyled fallback chip, a row sorted to the bottom), which is precisely
 * the kind of bug that ships unnoticed.
 *
 * Keep them in one place so a backend rename is a single edit here rather than
 * a hunt through feature folders.
 *
 * Display copy that merely contains the same words ("พนักงานขายจะไม่ได้รับสิทธิ์…")
 * is NOT part of this and should stay as plain literals.
 */
export const STAFF_ROLE = {
  SALESMAN: "พนักงานขาย",
  SPARE: "พนักงานเสริม",
  ASSISTANT: "ผู้ช่วยขาย",
} as const;

export type StaffRole = (typeof STAFF_ROLE)[keyof typeof STAFF_ROLE];
